/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * How a ChallengeDraw filters its qualification pool. NONE = every ACTIVE_CHALLENGE_MEMBER. ROUND = members who earned >= minPoints during the round (displayTab:true segment) containing drawAt. CAMPAIGN = members who earned >= minPoints across the entire campaign. CUSTOM_WINDOW = members who earned >= minPoints within an admin-supplied [start, end] window. Replaces the legacy boolean requireSegmentActivity flag (true == ROUND, false == NONE).
 * @export
 */
export const DrawQualificationScope = {
    NONE: 'NONE',
    ROUND: 'ROUND',
    CAMPAIGN: 'CAMPAIGN',
    CUSTOM_WINDOW: 'CUSTOM_WINDOW'
} as const;
export type DrawQualificationScope = typeof DrawQualificationScope[keyof typeof DrawQualificationScope];


export function instanceOfDrawQualificationScope(value: any): boolean {
    for (const key in DrawQualificationScope) {
        if (Object.prototype.hasOwnProperty.call(DrawQualificationScope, key)) {
            if (DrawQualificationScope[key as keyof typeof DrawQualificationScope] === value) {
                return true;
            }
        }
    }
    return false;
}

export function DrawQualificationScopeFromJSON(json: any): DrawQualificationScope {
    return DrawQualificationScopeFromJSONTyped(json, false);
}

export function DrawQualificationScopeFromJSONTyped(json: any, ignoreDiscriminator: boolean): DrawQualificationScope {
    return json as DrawQualificationScope;
}

export function DrawQualificationScopeToJSON(value?: DrawQualificationScope | null): any {
    return value as any;
}

export function DrawQualificationScopeToJSONTyped(value: any, ignoreDiscriminator: boolean): DrawQualificationScope {
    return value as DrawQualificationScope;
}

